<template>
    <div>
<h3 class="is-size-3">Enviar SMS</h3>
        <p> <code>POST {{ host }}/api/sendSms</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint recibe tres parametros en el Body:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>phone</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Formato a 10 digitos (Ej. 6141234567)</li>
                    </ul>
                </li>
                <li>
                    <strong>message</strong>
                     <ul>
                        <li>Obligatorio</li>
                        <li>Limitado a 140 caracteres</li>
                    </ul>
                </li>
                <li>
                    <strong>awsRegion</strong>
                    <ul>
                        <li>Opcional</li>
                    </ul>    
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5> 
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>{ 
            "status":"success",
            "message":"Se agrego el mensaje a la cola por enviar"
        }</code>
        </pre>
        <hr />
       
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }    
}
</script>

<style lang="scss" scoped>

</style>